import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';

import { Exporter } from './pdf-export';
import { InflateHandle } from './template-inflater';

@Injectable()
export class ScorecardExportService {
    private _hdl: InflateHandle;

    /** only scorecard.component should be calling this */
    // eslint-disable-next-line accessor-pairs
    set inflateHandle(value: InflateHandle) {
        this._hdl = value;
    }

    /** only scorecard.epic should be calling this */
    run(filename: string): Observable<void> {
        const exp = new Exporter();
        return from(exp.run(this._hdl, filename));
    }
}
